import { Link } from 'gatsby'
import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import BgImg from "../../images/cloud-support-and-maintenance-services/sub-banner.webp";

function SubBanner() {
  return (
    <section className='cloud__subbanner p-100' style={{ backgroundImage: `url(${BgImg})` }}>
        <Container>
            <Row>
                <Col
                 xs={12}
                 md={12}
                 lg={8}
                 xl={7}
                 xxl={6}
                >
                <div class="content">
                    <h2 className='title'>Scale The Potential of Your Cloud Infrastructure with TekRevol’s Cloud Support Services</h2>
                    <p>At TekRevol, we keep our clients’ cloud infrastructures performant, secure, compliant – and most importantly resilient so our clients can speed up their time to value. Let TekRevol navigate as you embrace and lead the change!</p>
                    <Link to="/" aria-label="Scale The Potential of Your Cloud Infrastructure with TekRevol’s Cloud Support Services" className="btn-pri">
                        Let’s discuss
                    </Link>
                </div>

                </Col>
            </Row>
        </Container>
    </section>
  )
}

export default SubBanner